import React from 'react';

import { FormikTextField } from 'components';
import { FormFieldProps, GetFieldValidatorFn } from 'types';

import { useTFeature } from '../fields.utils';
import { getBaseFieldValidator } from '../form.validators';

export const Field: React.FC<FormFieldProps> = ({
  name,
  required = false,
  disabled = false,
}) => {
  const { t } = useTFeature();

  return (
    <FormikTextField
      name={name}
      label={t('fields.payment_string.label')}
      fullWidth
      required={required}
      disabled={disabled}
    />
  );
};

export const getValidator: GetFieldValidatorFn = ({ required }) =>
  getBaseFieldValidator({ required }).nullable();
